export enum Directions {
  RTL = 'rtl',
  LTR = 'ltr',
}

export enum Languages {
  ENGLISH = 'en',
  ARABIC = 'ar',
}

export enum SubscriptionFlagsEnum {
  RECOMMENDED = 1,
  BEST_SELLER = 2,
  BIGGEST_DISCOUNT = 3,
  SPECIAL_OFFER = 4,
  BEST_FOR_BRANDING = 5,
}
